import React, { useState } from 'react';
import DatePicker from '../Calendar/DatePicker';
import Modal from '../StayPackage/components/Modal';
import i18n from '../i18n';
import { addDays } from 'date-fns';
import { formatDateWithDayOfWeek } from '../utils/dateHelper';

type FormDateProps = {
  formName: string;
  isRangeSelect?: boolean;
  minDate?: Date;
  maxDate?: Date;
  dateDuration?: number;
}

const FormDate: React.FC<FormDateProps> = ({formName, minDate, maxDate, dateDuration, isRangeSelect}) => {
  const [isModalShown, setModalShown] = useState(false);
  const [formValue, setFormValue] = useState<Date>();

  const handleOnClickForm = () => {
    setModalShown(true);
  }

  const selectedDateString = dateDuration == 1
    ? formValue ? formatDateWithDayOfWeek(formValue) : ''
    : formValue ? `${formatDateWithDayOfWeek(formValue)} - ${formatDateWithDayOfWeek(addDays(formValue, dateDuration - 1))}` : '';

  return (
    <>
      <button
        className='form-control bg-white w-100 d-flex justify-content-between align-items-center'
        type='button'
        onClick={handleOnClickForm}
      >
        <input
          type="hidden"
          id="scheduled-date-form"
          value={formValue ? formatDateWithDayOfWeek(formValue) : ''}
          readOnly
          required
          style={{border: 'none'}}
          disabled={isModalShown} name={formName}
          />
          { formValue ? selectedDateString : i18n.t('base.please_select') }
        <i className="fas fa-chevron-down" />
      </button>
      <Modal
        isShown={isModalShown}
        handleClose={() => { setModalShown(false); }}
      >
        <DatePicker
          isRangeSelect={isRangeSelect}
          minDate={minDate}
          maxDate={maxDate}
          dateDuration={dateDuration}
          currentMonth={minDate}
          handleDateListChange={(value) => {setFormValue(value[0])}}
        />
      </Modal>
    </>
  );
};

export default FormDate;
